import { CrudService } from './crud.service';
import { CarModelCreateUpdateDto as DTO } from '@shared/dto/car-model';
import { CarModelResource as Res } from '@shared/resources/car-model';

export class CarModelService extends CrudService<DTO, DTO, Res> {
  protected pathPrefix(): string {
    return 'car-models';
  }
}
